import React, { Component } from "react"
import PropTypes from "prop-types"

class ButtonLove extends Component {
  constructor( { list } ) {
    super()
    list.events.change.add( this.handleList )
  }

  componentWillUnmount() {
    let { list } = this.props
    list.events.change.remove( this.handleList )
  }

  handleList = ( { list } ) => {
    this.setState( { list } )
  }

  render() {
    let { as, list, product, children, elementActive, elementInActive } = this.props
    if ( !elementActive ) elementActive = children
    if ( !elementInActive ) elementInActive = children
    let activeClass = (list.contains( product ) ? "active" : false)
    if ( as ) {
      let { product, list, elementActive, elementInActive, as, ...rest } = this.props
      let Element = as
      return <Element
        className={`${this.props.className} ${activeClass}`}
        onClick={() => {
          list.toggle( product )
        }}
        {...rest} >{activeClass ? <span>{elementActive}</span> : <span>{elementInActive}</span>}</Element>
    }
    return (
      <div className={`${this.props.className} ${activeClass}`}
           onClick={() => {
             list.toggle( product )
           }}>{activeClass ? <span>{elementActive}</span> : <span>{elementInActive}</span>}</div>)
  }
}


ButtonLove.propTypes = {
  product:         PropTypes.object.isRequired,
  list:            PropTypes.object.isRequired,
  children:        PropTypes.any,
  elementActive:   PropTypes.any,
  elementInActive: PropTypes.any,

}


export default ButtonLove



// WEBPACK FOOTER //
// ./src/components/Button/ButtonLove.js